import React from 'react';

type Props = React.PropsWithChildren<{
  className?: string;
}>;

export const GlassCard = React.forwardRef<HTMLDivElement, Props>(
  ({ className = '', children }, ref) => {
    return (
      <div ref={ref} className={`glass glass-hairline rounded-lgx p-6 ${className}`}>{children}</div>
    );
  }
);

GlassCard.displayName = 'GlassCard';

export default GlassCard;

